import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import SearchIcon from '@material-ui/icons/Search';

import { fade } from '@material-ui/core/styles/colorManipulator';
import moment from 'moment'

import api from "../../../api/backend"

import Editor from './Editor'

const styles = theme => ({
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class Subject extends React.Component {
    state = {
        open: false, departmentId: '', level: '', subjectNo: '', title: '', description: '', subjects: [], tmpSubjects: [], departments: [], loading: false
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    getSubjects = () => {
        this.setState({ loading: true })
        api.getSubjects(true).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ subjects: json, tmpSubjects: json })
            }
        }).catch(() => { }).finally(() => {
            this.setState({ loading: false })
        })
    }

    getDepartments = () => {
        api.getDepartments().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ departments: json })
            }
        }).catch(() => { })
    }

    createSubject = () => {
        const { departmentId, level, subjectNo, title, description } = this.state;
        console.log(title, description);
        api.createSubject({ departmentId, level, subjectNo, title, description }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.getSubjects();
                this.setState({ open: false, departmentId: '', level: '', subjectNo: '', title: '', description: '' })
            } else {
                console.error('ไม่สามารถสร้างวิชาใหม่ได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    };

    find = () => {
        const { tmpSubjects, term } = this.state
        if (term.length > 0) {
            this.setState({ subjects: tmpSubjects.filter((e) => { return e.title.includes(term) || e.description.includes(term) }) })
        } else {
            this.setState({ subjects: tmpSubjects })
        }
    }

    componentDidMount() {
        this.getSubjects();
        this.getDepartments();
    }

    validate = () => {
        const { departmentId, level, subjectNo, title, description } = this.state;
        if (departmentId && level && subjectNo && subjectNo.length > 0 && title && title.length > 0 && description && description.length > 0) {
            return true
        } else {
            return false
        }
    }

    render() {
        const { classes } = this.props;
        const { departmentId, level, subjectNo, title, description, subjects, departments, loading } = this.state;
        return (
            <div>
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            วิชา
            </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.find()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>
                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <Button variant="contained" color="primary" fullWidth onClick={this.handleClickOpen}>
                                สร้างใหม่
                            </Button>
                        </Grid>
                    </Grid>
                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">วิชา</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                สร้าง และแก้ไขกลุ่มวิชา
                        </DialogContentText>
                            <Grid container spacing={24} style={{ paddingTop: 30 }}>
                                <Grid item xs={6}>
                                    <FormControl style={{ minWidth: 240 }} fullWidth>
                                        <InputLabel htmlFor="demo-controlled-open-select">ชื่อกลุ่มวิชา</InputLabel>
                                        <Select
                                            value={departmentId}
                                            onChange={(event) => { this.setState({ departmentId: event.target.value }) }}
                                            inputProps={{
                                                name: 'department',
                                                id: 'department-simple',
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>กรุณาเลือก</em>
                                            </MenuItem>
                                            {departments.map(department => (
                                                <MenuItem value={department.id}>{department.title}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl style={{ minWidth: 240 }} fullWidth>
                                        <InputLabel htmlFor="demo-controlled-open-select">ระดับชั้น</InputLabel>
                                        <Select
                                            value={level}
                                            onChange={(event) => { this.setState({ level: event.target.value }) }}
                                            inputProps={{
                                                name: 'level',
                                                id: 'level-simple',
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>กรุณาเลือก</em>
                                            </MenuItem>
                                            <MenuItem value="ประถมศึกษา ปีที่ 1">ประถมศึกษา ปีที่ 1</MenuItem>
                                            <MenuItem value="ประถมศึกษา ปีที่ 2">ประถมศึกษา ปีที่ 2</MenuItem>
                                            <MenuItem value="ประถมศึกษา ปีที่ 3">ประถมศึกษา ปีที่ 3</MenuItem>
                                            <MenuItem value="ประถมศึกษา ปีที่ 4">ประถมศึกษา ปีที่ 4</MenuItem>
                                            <MenuItem value="ประถมศึกษา ปีที่ 5">ประถมศึกษา ปีที่ 5</MenuItem>
                                            <MenuItem value="ประถมศึกษา ปีที่ 6">ประถมศึกษา ปีที่ 6</MenuItem>
                                            <MenuItem value="มัธยมศึกษา ปีที่ 1">มัธยมศึกษา ปีที่ 1</MenuItem>
                                            <MenuItem value="มัธยมศึกษา ปีที่ 2">มัธยมศึกษา ปีที่ 2</MenuItem>
                                            <MenuItem value="มัธยมศึกษา ปีที่ 3">มัธยมศึกษา ปีที่ 3</MenuItem>
                                            <MenuItem value="มัธยมศึกษา ปีที่ 4">มัธยมศึกษา ปีที่ 4</MenuItem>
                                            <MenuItem value="มัธยมศึกษา ปีที่ 5">มัธยมศึกษา ปีที่ 5</MenuItem>
                                            <MenuItem value="มัธยมศึกษา ปีที่ 6">มัธยมศึกษา ปีที่ 6</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="subjectNo"
                                        name="subjectNo"
                                        label="รหัสวิชา"
                                        fullWidth
                                        value={subjectNo}
                                        onChange={(event) => { this.setState({ subjectNo: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="title"
                                        name="title"
                                        label="ชื่อวิชา"
                                        fullWidth
                                        value={title}
                                        onChange={(event) => { this.setState({ title: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="description"
                                        name="description"
                                        label="รายละเอียด"
                                        fullWidth
                                        multiline
                                        rows={6}
                                        value={description}
                                        onChange={(event) => { this.setState({ description: event.target.value }) }}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                ปิด
                        </Button>
                            <Button onClick={this.createSubject} color="primary" disabled={!this.validate()}>
                                สร้าง
                        </Button>
                        </DialogActions>
                    </Dialog>
                    <br /><br />
                    {loading && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 0' }}>
                            <CircularProgress size={80} thickness={4} />
                            <Typography variant="title" color="textSecondary" style={{ marginTop: 24 }}>
                                กำลังโหลด...
                            </Typography>
                        </div>
                    )}
                    <Paper style={{ display: loading ? 'none' : 'block' }}>
                        <Table padding="dense">
                            <TableHead>
                                <TableRow>
                                    <TableCell>ชื่อวิชา</TableCell>
                                    <TableCell>ชื่อกลุ่มวิชา</TableCell>
                                    <TableCell>ระดับชั้น</TableCell>
                                    <TableCell align="right">แก้ไขล่าสุด</TableCell>
                                    <TableCell align="right">สถานะ</TableCell>
                                    <TableCell align="right" style={{ width: 200 }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {subjects.map(subject => (
                                    <TableRow key={subject.id}>
                                        <TableCell component="th" scope="row">
                                            {subject.title}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {subject.department.title}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {subject.level}
                                        </TableCell>
                                        <TableCell align="right">{moment(subject.modified).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="right">{subject.deactivated ? 'ไม่ใช้งาน' : ' ใช้งาน'}</TableCell>
                                        <TableCell>
                                            <Editor subject={subject} onUpdateCompleted={this.getSubjects}/>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
            </div>
        );
    }
}

Subject.propTypes = {
};

export default withStyles(styles)(Subject);